import type { TCallSimulationForm } from '@hooks/useCallSimulation';

export function encodeCallSimulation(call: Nullable<TCallSimulationForm>): Nullable<string> {
  if (call == null) {
    return null;
  }

  try {
    return encodeURIComponent(btoa(JSON.stringify(call)));
  } catch {
    return null;
  }
}
